var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentIs,{tag:"component",staticClass:"container",class:{ 'is-narrow': _vm.narrow, 'is-medium': _vm.medium, 'is-fluid': _vm.fluid }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }